import HomeIcon from '@mui/icons-material/Home';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import GamepadIcon from '@mui/icons-material/Gamepad';
import { uuid } from './uuid';
import { PATHS } from '../routes/paths';
import {
  TotalVolIcon,
  AxiesIcon,
  TotalSaleIcon,
  EtherIcon,
} from '../assets/svg';
import {
  AquaticImg,
  BeastImg,
  BirdImg,
  BugImg,
  DawnImg,
  DuskImg,
  MechImg,
  PlantImg,
  ReptileImg,
  Person1,
  Person2,
  Person3,
  Person4,
  Person5,
} from '../assets/img';

export const landingSliderData = [
  {
    id: uuid(),
    heading: 'We Wojakians',
    body: 'We are trusted by valid people such as Elon Musk and CZ.Also, We have gained the trust of more than 60k people.',
  },
  {
    id: uuid(),
    heading: 'We Wojakians',
    body: 'We are trusted by valid people such as Elon Musk and CZ.Also, We have gained the trust of more than 60k people.',
  },
  {
    id: uuid(),
    heading: 'We Wojakians',
    body: 'We are trusted by valid people such as Elon Musk and CZ.Also, We have gained the trust of more than 60k people.',
  },
];

export const thisWeekLandingData = {
  heading: 'this week in Woj Finance',
  body: 'General stats from the past 7 days in the Woj Finance.',
  cardsData: [
    {
      id: uuid(),
      title: 'New Feature',
      variable: '18,930',
    },
    {
      id: uuid(),
      title: 'New NFTs',
      variable: '212,420',
    },
    {
      id: uuid(),
      title: 'New Users',
      variable: '1929',
    },
  ],
};

export const SideBarData = [
  { id: uuid(), name: 'Home', icon: <HomeIcon />, path: PATHS.root },
  {
    id: uuid(),
    name: 'Marketplace',
    icon: <ShoppingBagIcon />,
    path: PATHS.marketPlace,
  },
  { id: uuid(), name: 'Games', icon: <GamepadIcon />, path: PATHS.games },
];

export const MarketPlaceOverall = [
  { id: uuid(), title: 'TOTAL SALES', amount: '8,040', imgSrc: TotalSaleIcon },
  {
    id: uuid(),
    title: 'TOTAL VOLUME',
    amount: '101.39',
    imgSrc: TotalVolIcon,
    secondSrc: EtherIcon,
  },
  { id: uuid(), title: 'AXIES SOLD', amount: '6,310', imgSrc: AxiesIcon },
];

export const marketFilterClass = [
  { id: uuid(), name: 'Beast', imgSrc: BeastImg, color: '#fdb014' },
  { id: uuid(), name: 'Aqutic', imgSrc: AquaticImg, color: '#00f5f8' },
  { id: uuid(), name: 'Plant', imgSrc: PlantImg, color: '#afdb1b' },
  { id: uuid(), name: 'Bug', imgSrc: BugImg, color: '#ff433e' },
  { id: uuid(), name: 'Bird', imgSrc: BirdImg, color: '#fa59a0' },
  { id: uuid(), name: 'Reptile', imgSrc: ReptileImg, color: '#9967fb' },
  { id: uuid(), name: 'Mech', imgSrc: MechImg, color: '#71898e' },
  { id: uuid(), name: 'Dawn', imgSrc: DawnImg, color: '#7183e3' },
  { id: uuid(), name: 'Dusk', imgSrc: DuskImg, color: '#029fae' },
];

export const marketSliderData = [
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person1,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person2,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person3,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person4,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person5,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person1,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person2,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person3,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person4,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
  {
    id: uuid(),
    health: '40%',
    age: '70',
    level: '20',
    imgSrc: Person5,
    name: 'Axie #11540418',
    caption: 'Ahura | Mazda → Dqrk | Bye V2',
    icon: BeastImg,
    detailName: 'energizer',
    hashtagId: '#11540418',
  },
];
